import SimpleDataTable from "./SimpleDataTable";

export default SimpleDataTable;